"use client"

import { usePathname } from "next/navigation"

import { config } from "src/config"

import A from "./A"

export default function Footer() {
  const pathname = usePathname()

  return (
    <footer className="bg-background">
      <div className="mx-auto grid w-full max-w-4xl gap-x-page-x gap-y-12 px-page-x py-12">
        <ul>
          <li>{config.email}</li>
          <li>{config.phone}</li>
        </ul>

        <nav className="whitespace-nowrap">
          <ul className="grid gap-x-8 gap-y-4">
            {pathname !== "/" ? (
              <li>
                <A href={config.pages.index}>Zurück</A>
              </li>
            ) : null}
            <li>
              <A href={config.pages.impressum}>Impressum</A>
            </li>
            <li>
              <A href={config.pages.datenschutz}>Datenschutz</A>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  )
}
